import React, { useEffect, useState } from "react";
import { performance } from "../../data";

const PerformanceNavigation = ({ sectionRefs }) => {
  const sections = performance.sections;
  const [activeSection, setActiveSection] = useState(sections[0]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    Object.values(sectionRefs).forEach((ref, i) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      Object.values(sectionRefs).forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [sectionRefs]);

  return (
    <div className="col-md-3">
      <ul className="tab-nav rounded-lg">
        {sections.map((item, index) => {
          const activeIndex = sections.indexOf(activeSection);
          let className = "";

          if (index === activeIndex) {
            className = "active";
          } else if (index < activeIndex) {
            className = "complete";
          }

          return (
            <li key={index} className={className}>
              <a href={`#${item}`} role="tab">
                {item}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PerformanceNavigation;
